<script setup lang="ts">
import { computed } from 'vue'
import InputText from 'primevue/inputtext'
import { useField } from 'vee-validate'

const props = defineProps<{
  modelValue?: string
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<string>(props.inputName);

const computedValue = computed({
  get: () => props.modelValue,
  set: (newVal: string) => {
    value.value = newVal;
    emit('update:modelValue', newVal);
  }
})

</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="batchNumber">Batch Number:</label>
    <InputText
      id="batchNumber"
      :disabled="disabled"
      :invalid="!!errorMessage"
      v-model="computedValue"
    />
  </div>
</template>

<style scoped>

</style>